const pjson = require('../../package.json');

export const environment = {
    production: false,
    version: pjson.version,
    tenantId: 'default',
    server: {
        protocol: 'https',
        host: 'api.staging.tuti.education',
        port: 443,
        apiPath: 'api/'
    },
    websocket: {
        host: 'api.staging.tuti.education',
        port: 443
    },
    appTitle: "Tutì staging",
    configuration: <any>{},
    user: <any>{},
    swarmifyLoaded: false,
    websocketNotificationService: <any>Object,
    notificationService: <any>Object,
    userService: <any>Object,
    ImageAssets: <any>{},
    tt01DBVersion: 1,
    webDeviceUUID: "",
    features: {
        enableRooms: true,
        enableSubscription: true,
        enableRegistration: true
    },
    gtag: {
        enabled: false,
        gtmIframeID: "GTM-XXXXXXX",
        config1: "G-XXXXXXXXXX",
        config2: "G-YYYYYYYYYY"
    },
    iuBenda: {
        enabled: false,
        script1: {
            text: ``
        },
        script2: {
            src: ``
        }
    }
};